import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { switchMap, map, catchError, of } from 'rxjs';
import { ServiceOrdersActions } from './actions';
import { ServiceOrdersService } from '../../../core/services/apis/service-orders/service-orders.service';



@Injectable()
export class ServiceOrderStoreEffects {
  constructor(
    private actions$: Actions,
    private apiService: ServiceOrdersService
  ) { }

  closeServiceOrder$ = createEffect(() =>
  this.actions$.pipe(
    ofType(ServiceOrdersActions.CloseServiceOrder),
    switchMap(({ data, serviceOrderId }) =>
      this.apiService.closeServiceOrder(data, serviceOrderId).pipe(
        map((serviceOrder) =>
          ServiceOrdersActions.CloseServiceOrderSuccess({ serviceOrder })
        ),
        catchError((error: HttpErrorResponse) =>
          of(ServiceOrdersActions.actionFailure({ error: error.message }))
        )
      )
    )
  )
);

  changeStatusServiceOrder$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ServiceOrdersActions.ChangeStatus),
      switchMap(({ status, serviceOrderId }) =>
        this.apiService.changeStatus(status, serviceOrderId).pipe(
          map((serviceOrder) =>
            ServiceOrdersActions.ChangeStatusSuccess({ serviceOrder })
          ),
          catchError((error: HttpErrorResponse) =>
            of(ServiceOrdersActions.actionFailure({ error: error.message }))
          )
        )
      )
    )
  );


  getServiceOrderByVehicleId$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ServiceOrdersActions.SearchAllServiceOrdersByVehicleId),
      switchMap(({ vehicleId }) =>
        this.apiService.getAllOrderServiceByVehicleId(vehicleId).pipe(
          map((serviceOrderList) =>
            ServiceOrdersActions.SearchAllServiceOrdersByVehicleIdSuccess({ serviceOrderList })
          ),
          catchError((error: HttpErrorResponse) =>
            of(ServiceOrdersActions.actionFailure({ error: error.message }))
          )
        )
      )
    )
  );

  getServiceOrderByOwner$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ServiceOrdersActions.SearchServiceOrdersByOwner),
      switchMap(({ ownerId }) =>
        this.apiService.getAllOrderServiceByOwner(ownerId).pipe(
          map((serviceOrderList) =>
            ServiceOrdersActions.SearchServiceOrdersByOwnerSuccess({ serviceOrderList })
          ),
          catchError((error: HttpErrorResponse) =>
            of(ServiceOrdersActions.actionFailure({ error: error.message }))
          )
        )
      )
    )
  );

  getAllServiceOrder$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ServiceOrdersActions.SearchAllServiceOrders),
      switchMap(() =>
        this.apiService.getAll().pipe(
          map((serviceOrderList) =>
            ServiceOrdersActions.searchAllServiceOrdersSuccess({ serviceOrderList })
          ),
          catchError((error: HttpErrorResponse) =>
            of(ServiceOrdersActions.actionFailure({ error: error.message }))
          )
        )
      )
    )
  );

  getServiceOrderByTechnical$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ServiceOrdersActions.SearchServiceOrdersByTechnical),
      switchMap(({ technicalId }) =>
        this.apiService.getAllOrderServiceByTechnical(technicalId).pipe(
          map((serviceOrderList) =>
            ServiceOrdersActions.SearchServiceOrdersByTechnicalSuccsess({ serviceOrderList })
          ),
          catchError((error: HttpErrorResponse) =>
            of(ServiceOrdersActions.actionFailure({ error: error.message }))
          )
        )
      )
    )
  );

  createServiceOrder$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ServiceOrdersActions.createServiceOrder),
      switchMap(({ serviceOrder }) =>
        this.apiService.create(serviceOrder).pipe(
          map((serviceOrder) =>
            ServiceOrdersActions.CreateServiceOrderSuccess({ serviceOrder })
          ),
          catchError((error: HttpErrorResponse) =>
            of(ServiceOrdersActions.actionFailure({ error: error.message }))
          )
        )
      )
    )
  );
}
